var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M58 57l141 141m-141 0L199 57","fill":"none","stroke":"#0D3B5E","strokeWidth":"10"}));
}

Close.defaultProps = {"viewBox":"0 0 256 256","width":"32"};

module.exports = Close;

Close.default = Close;
